import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { HasAccessDirective } from '@shared/directives/has-access.directive';
import { TranslateModule } from '@ngx-translate/core';
import { VersionComponent } from '../../../components/version/version.component';
import { hdMenuItems, MenuItem, orgMenuItems } from '../menu-items';
import { StorageService } from '@core/services/storage/storage.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { APP_ROUTES } from '../../../../app.routes.model';
import { NgClass, NgStyle } from '@angular/common';
import { SideMenuItemComponent } from './side-menu-item/side-menu-item.component';
import { OverlayService } from '@core/services/overlay/overlay.service';
import { FeedbackDialogComponent } from '../../../components/feedback-dialog/feedback-dialog.component';
import { take } from 'rxjs';
import { NotificationService } from '@core/services/notification/notification.service';
import { HD_PUBLIC_WEB } from '../../../constants/constants';
import { ContactUsDialogComponent } from '../../../components/contact-us-dialog/contact-us-dialog.component';

@Component({
  selector: 'hd-side-menu',
  standalone: true,
  imports: [
    HasAccessDirective,
    TranslateModule,
    VersionComponent,
    RouterLink,
    NgClass,
    NgStyle,
    RouterLinkActive,
    SideMenuItemComponent,
  ],
  styleUrl: './side-menu.component.scss',
  templateUrl: './side-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'bg-surface-container relative' },
})
export class SideMenuComponent {
  private router = inject(Router);
  private overlayService = inject(OverlayService);
  private notificationService = inject(NotificationService);
  protected readonly HD_PUBLIC_WEB = HD_PUBLIC_WEB;
  protected menuItems$$ = computed<MenuItem[]>(() => {
    if (this.storageService.isHdUser$$()) {
      return hdMenuItems;
    }

    return orgMenuItems;
  });
  protected storageService = inject(StorageService);

  protected logout() {
    const isHdUser = this.storageService.isHdUser$$();

    this.storageService.cleanAuthStorage();
    this.router.navigate([APP_ROUTES.signIn], {
      queryParams: { hd: isHdUser },
    });
  }

  protected openFeedbackDialog() {
    this.overlayService.render(FeedbackDialogComponent, (c) => {
      c.instance.submittedSuccessfully.pipe(take(1)).subscribe(() => {
        this.notificationService.showSuccess(
          'feedbackDialog.notification.success',
        );
      });
    });
  }

  protected openContactDialog() {
    this.overlayService.render(ContactUsDialogComponent);
  }
}
